import React from 'react';
import Image from '../../../img/MainWebsite/RestaurantsPage.png';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

function ForRestaurants() {

  let navigate = useNavigate();

  return (
    <main >
      <Header />
      <div className={'mainContent  whiteFont'}>
        <div className={'column'}>
          <h2 className={'left blue'}>BRING YOUR MENU TO LIFE  </h2>
          <h5 className={'left'}>Designed for Restaurants: </h5>
          <ul className={"two-columns"}>
            <li className={'blue left'}><h5>Supplements printed menus—never replaces them </h5></li>
            <li className={'blue left'}><h5>Accessible on guests’ own phones or tablets  </h5></li>
            <li className={'blue left'}><h5>Highlights food, wine, spirits, cocktails, and more   </h5></li>
            <li className={'blue left'}><h5>Supports staff and reduces the burden on the kitchen and management </h5></li>
            <li className={'blue left'}><h5>Generate an additional revenue stream  </h5></li>
            <li className={'blue left'}><h5>No investment, no setup fees, no hardware, no training, no downloads, and no financial risk  </h5></li>
            <li className={'blue left'}><h5>Exclusively branded for your restaurant </h5></li>
          </ul>

          <h5 className={'left'}>You invest time, creativity, and intention into every dish and drink you serve. Your menu should reflect that
            same level of care—setting expectations, guiding choices, and supporting the overall dining experience. </h5>
          <h5 className={'left'}>Vizo Menu provides a supplemental digital menu experience that enhances—rather than replaces—your
            existing menus. Accessible on guests’ phones or tablets, it presents your offerings clearly and consistently with
            vivid imagery, thoughtful descriptions, key details, and critical allergy notes, all while complementing your
            printed menus and service style.  </h5>
          <h5 className={'left'}> Vizo Menu helps guests explore your menu with confidence
            and supports staff by answering common questions upfront. This reduces pressure on the kitchen and
            management during busy service periods, resulting in smoother flow, more confident ordering, and a more
            polished guest experience—without changing how your restaurant operates. </h5>
          <h5 className={'left'}>Restaurants can strengthen engagement and introduce an additional
            revenue stream through thoughtfully integrated sponsorships that enhance the guest experience without
            distraction.  </h5>
          <h5 className={'left'}>Designed to stay out of the way, the experience is exclusively branded for your restaurant, ensuring guests
            engage only with your menu, your style, and your brand. </h5>
          <h5 className={'left'}>Best of all, Vizo Menu is provided at no investment. Our business model allows us to deliver this enhancement
            with no setup fees, no hardware, no training, no downloads, and no financial risk—making it a simple, low-risk
            way to elevate how your menu is presented.  </h5>
          <h5 className={'blue left italic'}>Your menu, presented with the clarity and care it deserves. </h5>
        </div>
        <div className={'column'}>
          <img src={Image} className={'page-image image-border'} alt="Image 2" />
          <button className={' button-spacing chrome-background blue-link'} onClick={() => { navigate("/Contact-Us") }}>
            CONTACT US TO SCHEDULE A DEMO
          </button>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default ForRestaurants;